import Const from 'const';
import {FilterLineupsByCorrelationStackCombinationsInterface} from 'components/molecules/filter-lineups-by-correlation-stack-combinations/filter-lineups-by-correlation-stack-combinations-interface';
import {ComboUnitInterface} from 'components/organisms/correlation-stacking/interfaces/combo-unit';

class FilterLineupsByCorrelationStackCombinations implements FilterLineupsByCorrelationStackCombinationsInterface {
    constructor(
        private readonly checkedCombinations: ComboUnitInterface[] = [],
        private readonly lineupIds: string[] = [],
    ) {}
    hasCheckedCombinations(): boolean {
        return !isEmpty(this.checkedCombinations);
    }
    isComboChecked(comboUnit: ComboUnitInterface): boolean {
        for (const checkedCombo of this.checkedCombinations) {
            if (checkedCombo.getUnitId() === comboUnit.getUnitId()) {
                return true;
            }
        }

        return false;
    }
    getCheckedCombinations(): ComboUnitInterface[] {
        return this.checkedCombinations;
    }
    getLineupIds(): string[] {
        return this.lineupIds;
    }
    getLineupsQuantity(): number {
        return this.lineupIds.length;
    }
}

const filterLineupsByCorrelationStackCombinations = new FilterLineupsByCorrelationStackCombinations();

export default function (state = filterLineupsByCorrelationStackCombinations, action) {
    switch (action.type) {
        case Const.FILTER_LINEUPS_BY_CORRELATION_STACK_COMBINATIONS_SET_COMBO:
            const {checkedCombinations, lineupIds} = action.data;

            return new FilterLineupsByCorrelationStackCombinations(checkedCombinations, lineupIds);

        case Const.FILTER_LINEUPS_BY_PLAYERS_SET_PLAYER:
        case Const.UNSET_LINEUPS:
        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return new FilterLineupsByCorrelationStackCombinations();

        default:
            return state;
    }
}
